import { render, staticRenderFns } from "./AffiliatedBrandTable.vue?vue&type=template&id=1c662e95&scoped=true&"
import script from "./AffiliatedBrandTable.vue?vue&type=script&lang=js&"
export * from "./AffiliatedBrandTable.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatedBrandTable.vue?vue&type=style&index=0&id=1c662e95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c662e95",
  null
  
)

export default component.exports